import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const dependentsSelector = (state: RootState) => state.amwell.consumer.dependents;

export const dependentsDataSelector = createSelector(dependentsSelector, d => d.data);
export const dependentsDataErrorSelector = createSelector(dependentsSelector, d => d.errors.data);
export const dependentsDataLoadingSelector = createSelector(
  dependentsSelector,
  d => d.loading.data
);

export const dependentsActionLoadingSelector = createSelector(
  dependentsSelector,
  d => d.loading.action
);
export const dependentsActionErrorSelector = createSelector(
  dependentsSelector,
  d => d.errors.action
);
